import axios from "axios";
import { handleJWT, rmStorageAndReload } from "./handleJWT";

const SERVER_URL = `${process.env.REACT_APP_SITEURL}/influencer`;
// const SERVER_URL = `http://localhost:4016/influencer`;

const getInfoInfluencerApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/getInfoInfluencer`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getInfoInfluencerApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const checkfreecodeforuseApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/checkfreecodeforuse`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await checkfreecodeforuseApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const registerInfluencerApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/register`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await registerInfluencerApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const registerStep2Api = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/registerStep2`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await registerStep2Api(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const editInfoInfluencerApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/editInfoInfluencer`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await editInfoInfluencerApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const requestinfluencercodeApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/requestinfluencercode`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await requestinfluencercodeApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const showrequestinfluencercodeApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/showrequestinfluencercode`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await showrequestinfluencercodeApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const editrequestinfluencercodeApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/influencer/editrequestinfluencercode`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await editrequestinfluencercodeApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

export {
  getInfoInfluencerApi,
  registerInfluencerApi,
  registerStep2Api,
  editInfoInfluencerApi,
  requestinfluencercodeApi,
  editrequestinfluencercodeApi,
  showrequestinfluencercodeApi,
  checkfreecodeforuseApi,
};
